<template>
    <Section class="resources grid--resources">
        <h2 v-if="title">{{ title }}</h2>

        <Tabs
            @changedTab="val => $emit('changedTab', val)"
            @initiatedTabs="val => $emit('initiatedTabs', val)"
        >
            <Tab
                v-for="(category, ind) in tabCategories"
                :key="`r-tab-${category}`"
                :name="`${shrinkAreaTabTitles(category)} (${ getArrayLength(category) })`"
                :tabReference="category"
                :selected="ind === 0"
            >
                <template v-if="(category == 'undefined' || category == '' || !category) && isAdmin">
                    <CardResource
                        v-for="resource in resources.filter(r => r.category == 'undefined')"
                        :key="resource.id"
                        :isSearch="isSearch"
                        :showArea="showArea"
                        v-bind="resource"
                    >
                        {{ resource }}
                    </CardResource>
                </template>

                <section
                    :class="`resources__group ${navReference}${group}`"
                    :id="`${navReference}${convertKebabCase(group)}`"
                    v-for="group in resourceGroups"
                    :key="`r-${category}-${group}`"
                    v-show="getGroupLength(category, group) > 0"
                    :ref="`r-${group}`"
                    :name="group"
                >
                    <h3 class="resources__group-title">{{ group | titleCase }}</h3>

                    <div
                        class="resources__types"
                        v-for="type in resourceTypes"
                        :key="`r-${category}-${group}-${type}`"
                        v-show="filterResources(category, group, type).length > 0"
                    >
                        <p class="resources__type-label" v-if="type !== 'document'">
                            {{ type | titleCase }}
                        </p>

                        <CardResource
                            v-for="resource in filterResources(category, group, type)"
                            :key="resource.id"
                            :isSearch="isSearch"
                            :showArea="showArea"
                            v-bind="resource"
                        >
                            {{ resource }}
                        </CardResource>
                    </div>
                </section>

                <Content v-if="getArrayLength(category) < 1">
                    <h3>No Resources</h3>
                    Sorry, there are no resources found in <strong>{{ category }}</strong>
                </Content>
            </Tab>
        </Tabs>
    </Section>
</template>

<script>
import { kebabToTitle, toKebabCase } from '@/helpers'
import { mapGetters } from 'vuex'

export default {
    props: {
        isSearch: { type: Boolean, default: false },
        showArea: { type: Boolean, default: false },
        resources: { type: Array, required: true },
        navReference: { type: String, default: '1rSChild-' },
        title: { type: String }
    },

    data() {
        return {
            windowWidth: null
        }
    },

    created () {
        this.onResize()
        window.addEventListener('resize', this.onResize)
    },

    computed: {
        ...mapGetters('Auth', ['isAdmin']),

        width () { return this.windowWidth },
        tabCategories () {
            const tabOrder = {
                'Presentation & Triage': 10,
                'Assessment & Management': 20,
                'Discharge & Referral': 30
            }

            const tabs = this.generateTabArrays('category').sort((a, b) => tabOrder[a] - tabOrder[b])

            if (this.isAdmin) return tabs
            return tabs.filter(tab => tab !== 'undefined' && tab !== '' && tab) // if general user, hide undefined tabs
        },

        resourceGroups () {
            return this.generateTabArrays('group')
                .sort((a, b) => {
                    if (a.toLowerCase() < b.toLowerCase()) return -1
                    if (a.toLowerCase() > b.toLowerCase()) return 1
                    return 0
                })
        },
        resourceTypes () { return this.generateTabArrays('type') },
    },

    filters: {
        titleCase (val) {
            return kebabToTitle(val)
        }
    },

    methods: {
        convertKebabCase (val) {
            return toKebabCase(val)
        },

        shrinkAreaTabTitles (val) {
            if (this.width < 990 || (this.width > 1200 && this.width < 1430)) {
                if (val == 'Presentation & Triage') return "Presentation"
                if (val == 'Assessment & Management') return "Assessment"
                if (val == 'Discharge & Referral') return "Discharge"
            }

            return val
        },

        onResize() {
            this.windowWidth = window.innerWidth
        },

        generateTabArrays (type) {
            // dynamically create the list of tabs
            const newArr = this.resources.reduce((acc, resource) => {
                // We convert everything to lowercase for our checks, as sometimes
                // groups have been entered or suggest with sentence or title case.
                const allLowerCase = acc.map(a => a.toLowerCase())
                if (allLowerCase.includes(resource[type].toLowerCase())) return acc

                return [ ...acc, resource[type]]
            }, [])

            return newArr
        },

        getArrayLength (arr, type = 'category') {
            return this.resources
                .filter(res => res[type] === arr).length
        },

        getGroupLength (category, group) {
            return this.resources
                .filter(res => res.category == category)
                .filter(res => res.group == group).length
        },

        filterResources (category, group, type) {
            return this.resources
                .filter(res => res.category.toLowerCase() == category.toLowerCase())
                .filter(res => res.group.toLowerCase() == group.toLowerCase())
                .filter(res => res.type.toLowerCase() == type.toLowerCase())
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    }
}
</script>
